import NumberValue from "../../value/NumberValue";
import Values from "../../value/Values";
import UpgradeCreator from "./UpgradeCreator";

export default class MinedUpgradeCreator extends UpgradeCreator {
    /**
     * @abstract
     * @param {string} id 
     * @param {Values} values
     * @param {NumberValue} multiplierValue 
     */
    constructor(id, values, multiplierValue) {
        super(id);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        /**
         * @constant
         * @type {NumberValue}
         */
        this.multiplierValue = multiplierValue;
    }

    /**
     * @returns {number}
     */
    getUpgradeBonusMultiplier() {
        ////////////////////////////////////////////////
        // Check for Active Skill: Upgrade Bonus
        ////////////////////////////////////////////////

        const upgradeBonusMultiplier = this.multiplierValue.getValue();
        if (upgradeBonusMultiplier > 1) {
            return upgradeBonusMultiplier;
        }

        return 1;
    }

}